angular.module('unergie.main')
.directive('ttpayment', ($q, $window, ApiUser, AlertManager, AccountService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/ttpayment/ttpayment.html',
        scope: {
            payment: '=',
            raw: '=',
        },
    }),
)
